import { FormattedMessage } from "react-intl";

interface RoundedContainerWithBadgedHeaderInterface {
    Icon: React.ForwardRefExoticComponent<
        React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>
    >;
    title: string;
    children: React.ReactNode;
}

export default function RoundedContainerWithBadgedHeader({
    Icon,
    title,
    children,
}: RoundedContainerWithBadgedHeaderInterface) {
    return (
        <div className="bg-white sm:rounded-xl sm:border sm:border-gray-300 p-6 sm:p-4">
            <div className="flex items-center text-lg text-gray-900">
                <Icon className="size-6" />
                <span className="ml-2 font-semibold">
                    <FormattedMessage id={title} />
                </span>
            </div>
            {children}
        </div>
    );
}
